import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Naukasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Naukasana.title1"), context: t("Naukasana.context1") },
      { title: t("Naukasana.title2"), context: t("Naukasana.context2") },
      { title: t("Naukasana.title3"), context: t("Naukasana.context3") },
      { title: t("Naukasana.title4"), context: t("Naukasana.context4") },
      { title: t("Naukasana.title5"), context: t("Naukasana.context5") },
      { title: t("Naukasana.title6"), context: t("Naukasana.context6") },
      { title: t("Naukasana.title7"), context: t("Naukasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Naukasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/Naukasana.mp4'}
                title="Description"
                context={t("Naukasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Naukasana
